import React from 'react'
import './FeedProfileSection.css'

import { FaUser } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";

import profileBackground from '../image/profileBackgeound.jpg'
import profileImage from '../image/profileImg.jpg'
import { CiMail } from "react-icons/ci";
import { FaPhoneAlt } from "react-icons/fa";
import { FaCarrot } from "react-icons/fa6";
import { MdModeEditOutline } from "react-icons/md";
import { Link } from 'react-router-dom';


const url = "https://partywitty.com/master/assets/uploads/";

export default function FeedProfileSection() {

    const userdata = JSON.parse(localStorage.getItem("userData"));


    return (
        <div className='live-reel-profile-f'>
            <div className='live-reel-profile-side-f-section'>

                <div className='live-reel-profile-side'>
                    <div className='live-reel-profile-side-background'>
                        <img src={profileBackground} alt="" />
                    </div>
                    <div className='live-reel-profile-side-name'>
                        <div className='live-reel-profile-side-name-edit'>
                            <h1>{userdata?.name}</h1>
                            <div className='live-reel-profile-side-name-edit-icon'>
                                <MdModeEditOutline />
                            </div>
                        </div>
                        <p><CiMail /> : {userdata?.email}</p>
                        <p><FaPhoneAlt /> : {userdata?.mobile}</p>
                        {/* <p>DOB : {userdata.dob}</p> */}
                        <p>Gender : {userdata?.gender}</p>
                        <p><FaCarrot /> : {userdata?.virtual_wallet}</p>

                        {/* <span>Address of the user</span> */}
                    </div>

                    <div className='live-reel-profile-side-img-profile'>
                        <img src={url + userdata?.img} alt="" />
                    </div>
                </div>

                <div className='live-reel-profile-side-tagline'>
                    <p>Are you a corporate employee</p>
                    <Link to='/crp-home'>
                        <h1>Enjoy corporate Benefits</h1>
                    </Link>
                </div>

                <div className='live-reel-profile-side-favorites'>
                    <h1>Favorites</h1>
                    <div className='live-reel-profile-side-favorites-list'>
                        <FaHeart color='red' />
                        <span>Restaurants</span>
                    </div>
                    <div className='live-reel-profile-side-favorites-list'>
                        <FaHeart color='red' />
                        <span>Events</span>
                    </div>
                    <div className='live-reel-profile-side-favorites-list'>
                        <FaHeart color='red' />
                        <span>Artists</span>
                    </div>
                </div>

            </div>
        </div>
    )
}
